import createInstance from '../libs/axios'
// baseURL configurable por env (REACT_APP_API_APP) para apuntar a un backend local;
// fallback al gateway de producción si no está definida.
const instance = createInstance(process.env.REACT_APP_API_APP || 'https://oboynogo6f.execute-api.sa-east-1.amazonaws.com/production')

export default instance